/**
 * Composable pour le chargement des données de formations
 * Limite: 100 lignes max
 */

import { ref } from 'vue'
import { toast } from 'vue-sonner'
import { formationsService } from '../../services/index.js'

const formationMessages = ref({})

export function useFormationsData() {
  const loadingFormations = ref(true)
  const formationsData = ref({})
  const sessionsData = ref([])
  const categoriesList = ref([])

  const loadFormationMessages = async () => {
    try {
      const data = await formationsService.getMessages()
      formationMessages.value = data.messages || data || {}
    } catch (err) {
      console.warn('Impossible de charger les messages depuis l\'API, utilisation des messages par défaut')
      formationMessages.value = {}
    }
  }

  const organizeFormationsByCategory = (formations) => {
    const formationsByCategory = {}
    formations.forEach(formation => {
      const cat = formation.CATEGORIE
      const nom = formation.NOM
      
      if (!cat || cat.trim() === '' || !nom || nom.trim() === '') return
      
      const normalizedCat = cat.trim()
      
      if (!formationsByCategory[normalizedCat]) {
        formationsByCategory[normalizedCat] = []
      }
      
      formationsByCategory[normalizedCat].push({
        // Clé unique du catalogue : le nom ne l'est pas (mêmes intitulés en 3H00 et 7H00).
        ID: formation.ID,
        NOM: nom.trim(),
        MESSAGE: formation.MESSAGE || '',
        INTER: formation.INTER || '',
        DUREE: formation.DUREE || '',
        NOMBRE: formation.NOMBRE || '',
        FORMULES: formation.FORMULES || [],
        'TARIF INTRA': formation['TARIF INTRA'] || '',
        DISPO: formation.DISPO || '',
        ORDER: formation.ORDER !== undefined && formation.ORDER !== null ? formation.ORDER : 0
      })
    })
    
    return formationsByCategory
  }

  /**
   * @param {{ onError?: () => void }} [options] `onError` remplace le toast
   *   d'échec : le formulaire de devis le dit dans son bandeau (P24), l'embed ne
   *   montant pas de Toaster.
   */
  const loadFormationsData = async ({ onError } = {}) => {
    try {
      loadingFormations.value = true
      await loadFormationMessages()

      const data = await formationsService.list()
      formationsData.value = organizeFormationsByCategory(data.formations)
      sessionsData.value = data.sessions || []
      categoriesList.value = (data.categories || []).map(c => c.nom)
    } catch (err) {
      if (onError) onError(err)
      else toast.error('Erreur lors du chargement des formations. Veuillez réessayer.')
    } finally {
      loadingFormations.value = false
    }
  }

  return {
    loadingFormations,
    formationsData,
    sessionsData,
    formationMessages,
    categoriesList,
    loadFormationsData
  }
}
